<template>
  <div class="modal-wrapper">
    <div class="content">
      <div v-if="contract.name" class="iframe">
        <iframe
          :src="source"
          style="width: 100%"
          frameborder="0"
        />
      </div>
      <div v-else-if="contractID && contract.content" v-html="contract && contract.content ? contract.content[$i18n.locale].body : ''">
      </div>
    </div>
    <div class="checkbox" v-if="!disableCheckbox" >
      <v-checkbox id="agree" v-model="agree" :label="contract && contract.content ? contract.content[$i18n.locale].check_text : $tf('I have read and agree to the Terms')" />
    </div>
  </div>
</template>

<script>
import useContracts from '~/commons/contracts'
const { getCheckedSource } = useContracts()
export default {
  name: 'DialogContract',
  props: {
    contract: {
      type: Object,
      required: true
    },
    disableCheckbox: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data: () => ({
    source: ''
  }),
  computed: {
    contractID () {
      return this.contract.contract_id
    },
    agree: {
      set () {
        this.$store.dispatch('dialog/setValid', !this.agree)
      },
      get () {
        return this.$store.state.dialog.valid
      }
    }
  },
  watch: {
    contractID () {
      this.$store.dispatch('dialog/setValid', false)
    }
  },
  beforeMount () {
    const locale = async () => {
      this.source = await this.getCheckedSource(this.$i18n.locale)
    }
    locale()
  },
  mounted () {
    if (this.disableCheckbox) {
      this.$store.dispatch('dialog/setValid', true)
    } else {
      this.$store.dispatch('dialog/setValid', false)
    }
  },
  methods: {
    getCheckedSource (locale) {
      return getCheckedSource(this.contract.name, locale)
    }
  }
}
</script>

<style lang="scss" scoped>
.modal-wrapper {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  overflow-y:hidden;
  height: 100%;
  .content {
    min-height: 50vh; // min height for safari / ios
    background-color: #f8f9f8;
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    overflow-y: hidden;
    flex-basis: 0;
    div {
      flex-grow: 1;
      padding: .5rem;
      overflow-y: scroll;
    }
    .iframe {
      flex-grow: 1;
      height: 100%;
      overflow-y: hidden;
      display: flex;
      flex-direction: column;
      iframe {
        flex-grow: 1;
        // margin-bottom: 2rem;
      }
      }
    }
  .checkbox {
    margin: 0;
    padding: .25rem;
  }
}

@media (max-width: 1024px) {
  .modal-wrapper {
    .content {
      min-height: 200px;
    }
    div.checkbox {
      position: relative;
      flex: .5;
      -webkit-box-flex: .25;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/dialog/types/DialogContract.vue